import { SYSTableDef } from "../../../../_ovlclient/src/library/table/tableapi"

export type TranslationType = {
  U_TransCode: string
  U_TransGroup: string
}

export type TblTranslationColumn = keyof TranslationType

export type TblTranslation = {
  [key: string]: TranslationType
}

export let tblTranslation: SYSTableDef = {
  id: "SYSTranslation",
  title: {
    show: true,
    translationKey: "SYSTranslationTitle",
    dialogTitle: { doNotDisplayId: true },
  },
  feature: "SYSTranslation",
  permission: "SYSTR",
  database: {
    dataIdField: "Id",
    dbInsertMode: "AutoIdentity",
    useSchema: true,
  },
  server: {
    endpoint: "translation",
  },

  features: {
    add: true,
    edit: true,
    delete: true,
    copy: true,
    headerMenu: true,
    multiSelect: true,
    multiDelete: true,
    multiEdit: true,
    multiCopy: true,
    filter: true,
    multiFilter: true,
  },
  options: {
    initial_sortCustom: {
      ovld: {
        sorts: {
          Main: {
            translationKey: "SYSTranslationGroupColIdentification",
            showInTitle: false,
            selected: true,
          },
        },
      },
    },
  },

  columns: {
    U_TransGroup: {
      ui: {
        labelTranslationKey: "SYSTranslationColGroup",
        thGroupTranslationKey: "SYSTranslationGroupColIdentification",
      },
      sortable: true,
      filter: {
        columnFilter: { type: "none" },
      },
      schema: {
        nullable: false,
        validator1ToUse: "MinLength",
        validator1Options: {
          val: 3,
        },
      },
    },
    U_TransCode: {
      ui: {
        labelTranslationKey: "SYSTranslationColCode",
        thGroupTranslationKey: "SYSTranslationGroupColIdentification",
      },
      sortable: true,
      schema: {
        nullable: false,
      },
    },
  },
}
